import AppFormContainer from '@nxsys/components/AppFormContainer';
import { StyledAppSelect } from '@nxsys/components/AppSelect/index.styled';
import { Form } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import StepCard from './StepCard';
import { getHolidayPaymentMethodOnboardingOptions } from '@nxsys/constants/AppConstants';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { IRELAND } from '@nxsys/store/constants/keys';

interface AddHolidayPayMethodProps {
  stepNumber: number;
  holidayPaymentMethod?: string | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddHolidayPayMethodValues = {
  holidayPaymentMethodValue: string;
};

const AddHolidayPayMethod: React.FC<AddHolidayPayMethodProps> = ({
  stepNumber,
  holidayPaymentMethod,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddHolidayPayMethodValues>();
  const { messages } = useIntl();
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);
  const isIreland = payrollCountry === IRELAND;

  const onFinish = (values: AddHolidayPayMethodValues) => {
    const params = {
      holidayPayMethod: values?.holidayPaymentMethodValue ?? null,
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addHolidayPayMethod'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          holidayPaymentMethodValue: holidayPaymentMethod ?? undefined,
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['prospect.onboarding.holidayPaymentMethod'] as string}
          name="holidayPaymentMethodValue"
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'] as string,
            },
          ]}
        >
          <StyledAppSelect
            options={getHolidayPaymentMethodOnboardingOptions(isIreland)}
            placeholder={
              messages[
                'prospect.onboarding.holidayPaymentMethod.placeholder'
              ] as string
            }
            showSearch
          />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddHolidayPayMethod;
